import { render } from "./IndexArticle.vue?vue&type=template&id=ace87672"
import script from "./IndexArticle.vue?vue&type=script&lang=js"
export * from "./IndexArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__